module.exports = ".interface-80 {\n  width: 50% !important; }\n\n.interface-20 {\n  width: 20% !important;\n  margin-left: 15px; }\n"